import { Link } from "react-router-dom"
import styles from "../style"
import { 
    Navbar,
    Billing,
    CardDeal,
    Business,
    Clients,
    CTA,
    Stats,
    Footer,
    Testimonials,
    Hero,
    Metrics 
} from './react-public';


const Public = () => {

    const content = (
        <div className="bg-primary w-full">
            <div className={`${styles.paddingX} ${styles.flexCenter}`}>
                <div className={`${styles.boxWidth}`}>
                    <Navbar/>
                </div>
            </div>
            <div className={`bg-primary ${styles.flexStart}`}>
                <div className={`${styles.boxWidth}`}>
                    <Hero/>
                    <Stats/>
                    <Business/>
                    <Billing/>
                    <CardDeal/>
                    <Testimonials/>
                    <CTA/>
                    <Footer/> 
                </div>
            </div>
        </div>
    )
    return (
        <>
            {/*<Metrics />*/}
            {content}
        </>
    )
}
export default Public